import { Injectable } from '@angular/core';
import { ServiceBase } from '../../shared/models/bases/serviceBase';
import { API_ENDPOINTS } from '../../shared/common/apiConstants';
import { BusinessType } from '../../shared/models/business';
import { BusinessTypeStore } from '../../stores/business';

@Injectable({ providedIn: 'root' })
export class BusinessTypeService extends ServiceBase<BusinessType> {
  constructor(businessTypeStore: BusinessTypeStore) {
    super(API_ENDPOINTS.businesses.types, businessTypeStore);
  }
}
